import $ from 'jquery';

class Kitchenplan {
    constructor($plan) {
        this.ajaxUrl = '/?type=72654';
        this.maxPersons = 99999;

        let self = this;
        this.$plan = $plan;
        this.$tableBody = $plan.find('tbody');
        this.$personCount = $plan.find('.kitchenplan__person-count');
        this.$totalRow = null;
        this.$newRow = null;
        this.totalDefault = [[0, 0], [0, 0], [0, 0], [0, 0], [0, 0]];
        this.total = $.extend(true, [], this.totalDefault);
        this.persons = {};
        this.blockedDays = [];
        this.newPersonIndex = 1;


        $.ajax({
            method: "POST",
            url: this.ajaxUrl,
            data: {
                plan: this.$plan.data('plan'),
            },
        }).done(function (data) {

            if (data.persons !== null) {
                self.persons = data.persons;
            }

            if (data.blockedDays !== undefined) {
                self.blockedDays = data.blockedDays;
            }

            let personKeys = Object.keys(self.persons);
            if (personKeys.length !== 0) {
                self.newPersonIndex = parseInt(personKeys[personKeys.length - 1]) + 1;
            }

            self.generateNewRow();

            self.generateTotalRow();

            for (const [i, person] of Object.entries(self.persons)) {
                self.generateRows(person, i);
            }

            self.updateData(false);
        });
    };

    generateRows(person, index) {
        let $inputRow = $('<tr>', {class: 'kitchenplan__input-row kitchenplan__row--hidden', 'data-index': index});
        let $previewRow = $('<tr>', {class: 'kitchenplan__preview-row', 'data-index': index});

        let $inputCell = $('<td>');
        $inputCell.append('<input class="kitchenplan__name-input" value="' + person.name + '" placeholder="Ihr Name (Pflichtangabe)">')
        let $button = $('<button class="button button--primary">Absenden</button>');
        $button.on('click', this.updatePerson.bind(this, index));
        $inputCell.append($button)

        let $previewInputCell = $('<td>');
        let $buttonWrap = $('<div class="kitchenplan__edit-buttons">');
        // let $deleteButton = $('<button class="kitchenplan__edit-button"><i class="fa-sharp fa-solid fa-trash"></i></button>')
        // $deleteButton.on('click', this.deletePerson.bind(this, index));
        // $buttonWrap.append($deleteButton);
        let $editButton = $('<button class="kitchenplan__edit-button"><i class="fa-sharp fa-solid fa-pen"></i></button>');
        $editButton.on('click', this.toggleInputRow.bind(this, index, true));
        $buttonWrap.append($editButton);
        $previewInputCell.append('<span class="kitchenplan__preview-name">' + person.name + '</span>');
        $previewInputCell.append($buttonWrap);

        $previewRow.append($previewInputCell);
        $inputRow.append($inputCell);

        person.days.forEach((day, i) => {
            this.generatePreviewCell($previewRow, i, day[0])
            this.generatePreviewCell($previewRow, i, day[1])

            this.generateCell($inputRow, i, day[0]);
            this.generateCell($inputRow, i, day[1]);
        })

        this.$newRow.before($previewRow);
        this.$newRow.before($inputRow);
    }

    generateNewRow() {
        this.$newRow = $('<tr>', {class: 'kitchenplan__input-row kitchenplan__input-row--new', 'data-index': 0});

        let $inputCell = $('<td>');
        $inputCell.append('<input class="kitchenplan__name-input" value="" placeholder="Ihr Name (Pflichtangabe)">')
        this.$newRow.append($inputCell);

        this.totalDefault.forEach((day, i) => {
            this.generateCell(this.$newRow, i, 0);
            this.generateCell(this.$newRow, i, 0);
        })

        this.$tableBody.append(this.$newRow);

        let $button = $('<button class="button button--primary">Absenden</button>');
        $button.on('click', this.addPerson.bind(this));

        this.$plan.append($button);
    }

    generateCell($row, day, value) {
        let $cell = $('<td class="kitchenplan__cell kitchenplan__input-cell" data-day="' + day + '"></td>')
        let $inputWrap = $('<label class="kitchenplan__check-wrap">');
        let $input = $('<input class="kitchenplan__check" value="1" type="checkbox">');

        if (value !== 0) {
            $input.prop('checked', 1);
        } else {
            $input.prop('checked', 0);
        }

        if ($.inArray(day, this.blockedDays) !== -1) {
            $input.attr('disabled', 'disabled');
            $input.prop('checked', 0);
        }

        $inputWrap.append($input);
        $inputWrap.append('<div class="kitchenplan__check-box"></div>');

        $cell.append($inputWrap);
        $row.append($cell);
    }

    generatePreviewCell($row, day, value) {
        let $previewCell = $('<td class="kitchenplan__cell kitchenplan__preview-cell" data-day="' + day + '"/>');

        if ($.inArray(day, this.blockedDays) !== -1) {
            value = -1;
        }

        $previewCell.attr('data-value', value)
        $row.append($previewCell);
    }

    generateTotalRow() {
        this.$totalRow = $('<tr>', {class: 'kitchenplan__total-row'});
        this.$totalRow.append('<td><strong>Insgesamt</strong></td>');

        this.total.forEach((day, i) => {
            this.$totalRow.append('<td class="kitchenplan__total" data-day="' + i + '"></td>')
            this.$totalRow.append('<td class="kitchenplan__total" data-day="' + i + '"></td>')
        });

        this.$tableBody.append(this.$totalRow);
    }

    updateData(saveToTable = true) {
        let maxPersons = this.maxPersons;
        this.total = $.extend(true, [], this.totalDefault);

        for (const [key, person] of Object.entries(this.persons)) {
            person.days.forEach((day, i) => {
                this.total[i][0] += day[0] !== 0 ? 1 : 0;
                this.total[i][1] += day[1] !== 0 ? 1 : 0;
            });
        }


        this.total.forEach((day, i) => {
            if ($.inArray(i, this.blockedDays) === -1) {
                this.$totalRow.find('.kitchenplan__total[data-day="' + i + '"]').eq(0).text(day[0]);
                this.$totalRow.find('.kitchenplan__total[data-day="' + i + '"]').eq(1).text(day[1]);

                this.$tableBody.find('.kitchenplan__input-row').each(function () {

                    for (let type = 0; type < 2; type++) {
                        let $inputCell = $(this).find('.kitchenplan__input-cell[data-day="' + i + '"]').eq(type);
                        if (day[type] >= maxPersons && $inputCell.find('input').prop('checked') === false) {
                            $inputCell.find('input').attr('disabled', 'disabled');
                        } else {
                            $inputCell.find('input').removeAttr('disabled');
                        }
                    }
                });
            }
        });

        this.$totalRow.find('.kitchenplan__total').each(function () {
            if (parseInt($(this).text()) >= maxPersons) {
                $(this).addClass('kitchenplan__total--valid');
            } else {
                $(this).removeClass('kitchenplan__total--valid');
            }
        });

        let personKeys = Object.keys(this.persons);
        this.$personCount.text(personKeys.length);

        this.updateRowStyling();

        if (saveToTable) {
            $.ajax({
                method: "POST",
                url: this.ajaxUrl,
                data: {
                    plan: this.$plan.data('plan'),
                    persons: this.persons
                },
            });
        }

    };

    updatePerson(index) {
        let $inputRow = this.$plan.find('.kitchenplan__input-row[data-index="' + index + '"]');
        let $previewRow = this.$plan.find('.kitchenplan__preview-row[data-index="' + index + '"]');

        this.persons[index].name = $inputRow.find('.kitchenplan__name-input').val();
        $previewRow.find('.kitchenplan__preview-name').text(this.persons[index].name);

        for (let i = 0; i < 5; i++) {
            let $day = $inputRow.find('.kitchenplan__cell[data-day="' + i + '"] input');
            this.persons[index].days[i][0] = $day[0].checked ? 1 : 0;
            this.persons[index].days[i][1] = $day[1].checked ? 1 : 0;

            let $preview = $previewRow.find('.kitchenplan__cell[data-day="' + i + '"]');
            if ($.inArray(i, this.blockedDays) === -1) {
                $preview.eq(0).attr('data-value', this.persons[index].days[i][0]);
                $preview.eq(1).attr('data-value', this.persons[index].days[i][1]);
            }
        }

        this.updateData();
        this.toggleInputRow(index);
    }

    deletePerson(index) {
        this.$tableBody.find('tr[data-index="' + index + '"]').remove();
        delete this.persons[index];

        if(Object.keys(this.persons).length === 0) {
            this.persons = true;
        }

        this.updateData();
    }

    toggleInputRow(index, open = false) {

        this.$tableBody.find('.kitchenplan__input-row').addClass('kitchenplan__row--hidden');
        this.$tableBody.find('.kitchenplan__preview-row').removeClass('kitchenplan__row--hidden');

        if (open) {
            this.$tableBody.find('.kitchenplan__input-row[data-index="' + index + '"]').removeClass('kitchenplan__row--hidden');
            this.$tableBody.find('.kitchenplan__preview-row[data-index="' + index + '"]').addClass('kitchenplan__row--hidden');
        }

        this.updateRowStyling();
    }

    addPerson() {
        let person = {
            name: this.$newRow.find('.kitchenplan__name-input').val(),
            days: []
        };

        this.totalDefault.forEach((day, i) => {
            let $day = this.$newRow.find('.kitchenplan__cell[data-day="' + i + '"] input');
            person.days.push([$day[0].checked ? 1 : 0, $day[1].checked ? 1 : 0]);
        });

        this.generateRows(person, this.newPersonIndex);

        this.persons[this.newPersonIndex] = person;
        this.newPersonIndex++;

        //Reset all inputs
        this.$newRow.find('.kitchenplan__name-input').val('');
        this.$newRow.find('.kitchenplan__cell input').prop('checked', 0);

        this.updateData();
    }

    updateRowStyling() {
        let self = this;
        setTimeout(function () {
            self.$tableBody.find('tr').removeClass('kitchenplan__row--even').removeClass('kitchenplan__row--odd');
            self.$tableBody.find('tr:not(.kitchenplan__row--hidden)').each(function (i) {
                if (i % 2 === 0) {
                    $(this).addClass('kitchenplan__row--odd');
                } else {
                    $(this).addClass('kitchenplan__row--even');
                }
            });
        }, 1)
    }
}

$('.kitchenplan').each(function () {
    new Kitchenplan($(this));
});
